export default __webpack_public_path__ + "e2a03d55a6c4adf27cd9fa105300de21.png";